import React from 'react';
import Container from './Container';
import ModalTitle from './ModalTitle';

var ModalHeader = function ModalHeader(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ModalTitle, null, title));
};

export default ModalHeader;